(function Incrementals() {
  var decrementButtons = document.querySelectorAll('button[data-action="decrement"]');
  var incrementButtons = document.querySelectorAll('button[data-action="increment"]');

  // product page callbacks for quantity
  function decrement(e) {
    e.preventDefault();
    var container = e.target.closest('.quantity-input');
    if (!container) return;

    var input = container.querySelector('input[type="number"]');
    if (!input) return;

    var value = Number(input.value);
    value--;
    input.value = value > 0 ? value : 1;
  }

  function increment(e) {
    e.preventDefault();
    var container = e.target.closest('.quantity-input');
    if (!container) return;

    var input = container.querySelector('input[type="number"]');
    if (!input) return;

    var value = Number(input.value);
    value++;
    input.value = value;
  }

  decrementButtons.forEach(function(btn) {
    btn.addEventListener('click', decrement);
  });

  incrementButtons.forEach(function(btn) {
    btn.addEventListener('click', increment);
  });
})();
